export class ApprovalLimit {
    approvalLimitId: number;
    azureGuid: string;
    contactId: number;
    marketId: number;
    marketName: string;
    value: number; 
}
